import React from 'react';
import { BenefitsSection } from './components/BenefitsSection';
import { BonusesSection } from './components/BonusesSection';
import { Footer } from './components/Footer';
import { GuaranteeFaq } from './components/GuaranteeFaq';
import { Hero } from './components/Hero';
import { OfferSection } from './components/OfferSection';
import { PainPoints } from './components/PainPoints';
import { RecipeCategories } from './components/RecipeCategories';
import { ScienceSection } from './components/ScienceSection';
import { Testimonials } from './components/Testimonials';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-cream text-forest" data-id="element-0">
      <Hero data-id="element-1" />
      <ScienceSection data-id="element-2" />
      <PainPoints data-id="element-3" />
      <BenefitsSection data-id="element-4" />
      <RecipeCategories data-id="element-5" />
      <BonusesSection data-id="element-6" />
      <Testimonials data-id="element-7" />
      <OfferSection data-id="element-8" />
      <GuaranteeFaq data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}